// "Aug 27, 3:13 PM · 3d ago" — the date it came in plus how long it's been waiting.
export const age = (iso) => {
    const mins = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
    if (Number.isNaN(mins)) return "";
    if (mins < 1) return "just now";
    if (mins < 60) return `${mins}m ago`;
    if (mins < 1440) return `${Math.floor(mins / 60)}h ago`;
    if (mins < 60 * 24 * 60) return `${Math.floor(mins / 1440)}d ago`;
    return `${Math.floor(mins / (1440 * 30))}mo ago`;
};

export const when = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    const opts = { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" };
    if (d.getFullYear() !== new Date().getFullYear()) opts.year = "numeric";
    return `${d.toLocaleString([], opts)} · ${age(iso)}`;
};
